/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).ready(function() {
  const import_product_search_field = $('.import_product_search_field');
  if (import_product_search_field.size() > 0) {

    const suggestion_template = function(object, forwarded_args) {
      let match;
      let template = import_product_search_field.data("suggestion-template").replace("{{id}}", object.id).replace("{{active_sku}}", object.reference).replace("{{designation}}",object.designation);

      const substitution_text = object.is_substitute ? '<span class="substitution_marker">Remplaçable par </span>' : "";
      template = template.replace("{{substitution_marker}}", substitution_text);

      if (object.highlight) {
        const values = $.map(object.highlight, (v, k) => v);

        match = values[0];
      } else {
        match = "";
      }

      return template.replace("{{match}}", match);
    };

    const dataSet = {
      source(query, cb) {
        return $.get(import_product_search_field.data("source"), {query}, data => cb(data.options, data.meta));
      },
      name: "remote",
      display(object){
        return object.reference + ' ' + object.designation;
      },
      templates: {
        suggestion: suggestion_template
      }
    };

    const options = {
      minLength: 3,
      debug: false
    };

    return import_product_search_field.autocomplete(options, dataSet).bind('autocomplete:selected', function(event, suggestion, dataset) {
      return $($(this).data("target-prefix")+"product_id").val(suggestion.id);
    });
  }
});
